import React from "react";
import Banner from "../common/Banner";
//import NativeAd from "./NativeAd";
import RoomsForRent from "../property/FeaturedProperty";
import Divider from "../common/Divider";
import RecentJobs from "../job/FeaturedJobs";
import { useEffect, useState } from "react";
import { initializeTagManager } from "../../TagManager";
import { Helmet } from "react-helmet-async";
import PopularCategories from "../common/PopularCategories";
import AdvertiseWithUs from "../template/AdvertiseWithUs";
// import HomeTopFeatured from "../common/TopFeatured";
import FeaturedBusiness from "../business/FeaturedBusiness";
import FeaturedEvents from "../events/FeaturedEvents";
import CustomAdd from "../common/CustomAdd";
import { store } from "../../app/store";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { resetEvent, resetSale, updateEvent } from "../../app/features/event/eventSlice";
import { resetTimer } from "../../app/features/timer/timerSlice";
import { resetAskSignup, resetGuest, setAskTicket, setHomeModal, unSetHomeModal } from "../../app/features/user/userSlice";
import FeaturedProducts from "../property/FeaturedProducts";
import { Modal } from "bootstrap";
import EventTicketsModal from "../events/EventTicketsModal";
import HomeExternalEventModal from "../events/HomeExternalEventModal";
import { getTicketingUrl, isExternalEvent, isHomePageInternalModal, shouldRenderHomePageModal } from "../../utils/eventTicketing";

function BodyContent(props) {
  const dispatch = useDispatch();
  const settings = useSelector((state) => state.companySetting.settings);
  const [homeModalEvent, setHomeModalEvent] = useState(null);
  const [homeModalIsExternal, setHomeModalIsExternal] = useState(false);

  function toggleMobilenav() {
    var body = document.body;
    var hasClass = body.classList.contains("nav2-is-toggled");
    if (hasClass) {
      document.body.classList.remove("nav2-is-toggled");
      document.body.classList.remove("body-no-scroll");
      document.getElementById("ham").textContent = "menu";
    }
  }

  const handleModalClose = async () => {
    const currentItems = store.getState().event.items;
    const tickets = Object.values(currentItems).reduce((acc, el) => {
      if (el != null) {
        acc.push({
          ticket_id: el.ticket_id,
          quantity: el.quantity,
        });
      }
      return acc;
    }, []);

    await axios.request({
      method: "POST",
      url: `${process.env.REACT_APP_BASE_URL}/api/unhold_tickets`,
      data: { tickets: tickets },
      headers: {
        Authorization: process.env.REACT_APP_API_KEY,
      },
    });
    dispatch(resetSale());
    dispatch(resetTimer());
    dispatch(setAskTicket());
    dispatch(resetAskSignup());
    dispatch(resetGuest());
  };

  function useCleanModalBackdrop(modalId) {
    const modalEl = document.getElementById(modalId);

    if (!modalEl) {
      const backdrops = document.querySelectorAll(".modal-backdrop");
      backdrops.forEach((el) => el.remove());
      document.body.classList.remove("modal-open");
      document.body.style.removeProperty("overflow");
      document.body.style.removeProperty("padding-right");
    }
  }

  function shouldOpenHomeModal(event, external) {
    if (!event) return false;
    if (external) return !!getTicketingUrl(event);
    return shouldRenderHomePageModal(event);
  }

  useEffect(() => {
    initializeTagManager();
    handleModalClose();
    dispatch(unSetHomeModal());
    useCleanModalBackdrop("exampleModalToggle");
    toggleMobilenav();
  }, []);

  useEffect(() => {
    if (settings && settings.home_modal_status === "1" && settings.home_modal_event) {
      fetchData(settings.home_modal_event);
    }
  }, [settings]);

  useEffect(() => {
    if (shouldOpenHomeModal(homeModalEvent, homeModalIsExternal)) {
      const timer = setTimeout(() => {
        const modalEl = document.getElementById("homePageModal");
        if (modalEl) {
          const modal = new Modal(modalEl);
          modal.show();
        }
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [homeModalEvent, homeModalIsExternal]);

  async function fetchData(id) {
    const Url = `${process.env.REACT_APP_BASE_URL}/api/events/${id}`;

    await axios
      .request({
        method: "GET",
        url: Url,
        headers: {
          Authorization: process.env.REACT_APP_API_KEY,
        },
      })
      .then(function (response) {
        const event = response.data.data;
        const external = isExternalEvent(event);

        setHomeModalEvent(event);
        setHomeModalIsExternal(external);

        if (external) {
          dispatch(unSetHomeModal());
          dispatch(resetEvent());
          return;
        }

        dispatch(updateEvent(event));
        dispatch(setHomeModal());
      })
      .catch(function (error) {
        console.error("Event fetch error:", error);
      });
  }

  const showExternalHomeModal = homeModalEvent && homeModalIsExternal && !!getTicketingUrl(homeModalEvent);
  const showInternalHomeModal = homeModalEvent && !homeModalIsExternal && isHomePageInternalModal(homeModalEvent);

  return (
    <>
      <Helmet>
        <title>{`Sahi Search - ${props.pageTitle}`}</title>
        <meta name="title" content={props.metaTitle} />
        <meta name="description" content={props.metaContent} />
      </Helmet>
      {showExternalHomeModal && <HomeExternalEventModal event={homeModalEvent} />}
      {showInternalHomeModal && <EventTicketsModal id={"homePageModal"} closeId={"homePageClose"} />}
      <Banner />
      <CustomAdd />
      <Divider />
      <FeaturedEvents home="home" />
      <Divider />
      <FeaturedProducts home="home" />
      <Divider />
      <FeaturedBusiness />
      {/* <HomeTopFeatured /> */}
      {/* <NativeAd/> */}
      <Divider />
      <RoomsForRent />
      <Divider />
      <RecentJobs />
      <Divider />
      {/* <NativeAd/> */}
      <PopularCategories />
      <Divider />
      <AdvertiseWithUs />
    </>
  );
}
export default BodyContent;
